module.exports = __webpack_public_path__ + "img/Banner_0.f92c19de.jpg";